import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class PreviewService {
  previewClicked$ = new BehaviorSubject<string | undefined>(undefined);
}
